import type { Theme } from '@mui/material';
import { Grid2 as Grid } from '@mui/material';
import type { ComponentProps } from 'react';
import { combineSx } from '@/utils/combineSx';

type SummaryCardProps = ComponentProps<typeof Grid>;

const summaryCardFooterStyles = {
  base: {
    marginTop: 'auto',
    justifyContent: 'flex-end',
    borderTop: (theme: Theme) => `1px solid ${theme.palette.divider}`,
    paddingTop: '0.75rem',
  },
};

const SummaryCardContentGrid = ({ children, sx, ...props }: SummaryCardProps) => {
  return (
    <Grid
      display='grid'
      gridTemplateColumns={{
        md: 'repeat(2, 1fr)',
        xxl: 'repeat(3, 1fr)',
      }}
      container
      spacing={3}
      sx={combineSx(sx)}
      data-id='summary-card-content-grid'
      {...props}
    >
      {children}
    </Grid>
  );
};

const SummaryCardFooter = ({ children, sx, ...props }: SummaryCardProps) => {
  return (
    <Grid
      display='flex'
      container
      sx={combineSx(summaryCardFooterStyles.base, sx)}
      data-id='summary-card-footer'
      {...props}
    >
      {children}
    </Grid>
  );
};

export { SummaryCardContentGrid, SummaryCardFooter };
